import {
  Divider,
  Stack,
  Text,
  Container,
  Box,
  HStack,
} from "@chakra-ui/react";

import { useContext } from "react";
import { TranslatedTextContext } from "../App.js";

export default function About({ color }) {
  const translatedText = useContext(TranslatedTextContext);

  return (
    <>
      <Container maxW={"3xl"} id="about">
        <Stack
          as={Box}
          textAlign={"center"}
          spacing={{ base: 8, md: 14 }}
          pb={{ base: 20, md: 36 }}
        >
          <Stack align="center" direction="row" px={4}>
            <HStack mx={4}>
              <Text color={`${color}.400`} fontWeight={800}>
                01
              </Text>
              <Text fontWeight={800}>{translatedText.aboutUs.name}</Text>
            </HStack>
            <Divider orientation="horizontal" />
          </Stack>
          <Text color={"gray.600"} fontSize={"xl"} px={4}>
            {translatedText.aboutUs.point2} </Text>
          <Text color={"gray.600"} fontSize={"xl"} px={4} py={1}>
            {translatedText.aboutUs.point3}
          </Text>
        </Stack>
      </Container>
    </>
  );
}

